import type { ReactNode } from 'react';

import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

import { RowRoot } from '../ScenarioGrid.style';

export const ScenarioSubRow = ({ subRowKey, children }: { subRowKey: string; children?: ReactNode }) => {
    const theme = useInterstateTheme();

    return (
        <RowRoot theme={theme} data-row={subRowKey} data-testid={`scenario-row-${subRowKey}`}>
            {children}
        </RowRoot>
    );
};
